import { Link } from 'gatsby';
import React, { SetStateAction, Dispatch, useEffect, useContext } from 'react';
import * as ArchiveStyles from './Archive.module.scss'
import BPTLButton from '../BPTLButton/BPTLButton';
import { BPTLContext, BPTLStates } from '../../lib/utils';

interface IBPTLBlock {
    post: any
    isVisible: boolean
    setPopup: Dispatch<SetStateAction<string | undefined>>
    siteId: number | null
    catName: string
}

const ConditionalLink = ({ linkType, uri, children, className }: any) => {
  if (linkType === 'external') {
    return (
      <a href={uri} className={className}>
        {children}
      </a>
    )
  }

  return (
    <Link to={uri} className={className}>
      {children}
    </Link>
  )
}

const BPTLBlock = ({post, isVisible, setPopup, siteId, catName} : IBPTLBlock) => {
  const bptlState = useContext(BPTLContext);
    return (
        <div className={ArchiveStyles.Block} key={post.id}>
            {post.homepagePreviewImage && (
                <ConditionalLink
                uri={post.uri ?? ''}
                linkType={post.linkType}
                className={ArchiveStyles.Block_Img}
                >
                {post.homepagePreviewImage && (
                    <img src={post.homepagePreviewImage ?? ''} alt={''} />
                )}
                </ConditionalLink>
            )}
            {post.featuredImage && (
                <ConditionalLink
                uri={post.uri ?? ''}
                linkType={post.linkType}
                className={ArchiveStyles.Block_Img}
                >
                {post.featuredImage && (
                    <img
                    src={post.featuredImage.node.sourceUrl ?? ''}
                    alt={''}
                    />
                )}
                </ConditionalLink>
            )}
            <div className={ArchiveStyles.Block_Text}>
                <ConditionalLink
                uri={post.uri ?? ''}
                linkType={post.linkType}
                >
                {post.title.replace('Best Places to Live:', '')}
                </ConditionalLink>
            </div>
            <div className={ArchiveStyles.BPTLButtonRow}>
              {bptlState === BPTLStates.REGIONAL && (
                <>
                  <BPTLButton
                      post={post} 
                      popupVisible={isVisible}
                      setPopup={setPopup}
                      siteId={siteId}
                      catName={catName}
                      />
                  <Link className={ArchiveStyles.ReadMoreButton} to={post.uri}
                  >
                      Read More
                  </Link>
                </>
              )}
            </div>
        </div>
    )
}

export default BPTLBlock;